import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    Renderer2,
    OnChanges,
    SimpleChanges,
} from "@angular/core";
import { CommonService } from "@fuse/services/common.service";
import { CertificateToolService } from "../certificate-tool.service";
import { CertificateUpdateService } from "../certificate-update.service";
import { SocialSharePostService } from "app/main/events/view-event/social-share-post/social-share-post.service";
import { AddEditEventService } from "app/main/events/edit-event/add-edit-event.service";
import { CreateBadgeDesignService } from "app/main/badge-design/create-badge-design/create-badge-design.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
    selector: "app-right-side-nav",
    templateUrl: "./right-side-nav.component.html",
    styleUrls: ["./right-side-nav.component.scss"],
})
export class RightSideNavComponent implements OnInit, OnChanges {
    @Output() dropClose = new EventEmitter();
    dynamicFieldList: [] = [];
    @Input("isForName") isForName: string;
    @Input("currentTab") currentTab: string;

    constructor(
        private el: ElementRef,
        private _CommonService: CommonService,
        private _SocialSharePostService: SocialSharePostService,
        private _CertificateToolService: CertificateToolService,
        private _CreateBadgeDesignService: CreateBadgeDesignService,
        private _CertificateUpdateService: CertificateUpdateService,
        private _AddEditEventService: AddEditEventService,
        private renderer: Renderer2,
        private _MatSnackBar: MatSnackBar
    ) {
        this._CertificateToolService.dynamicFieldList.subscribe((res) => {
            if (res?.length) {
                this.dynamicFieldList = res;

                // for selected field in update case.
                console.log(
                    "=============>",
                    this._CertificateUpdateService.templateDetails
                );
                console.log(
                    "dynamicFieldList==========>",
                    this.dynamicFieldList
                );

                if (this._CertificateUpdateService.templateDetails) {
                    if (
                        this._CertificateUpdateService.templateDetails?.layout
                            ?.dynamicElements?.length
                    )
                        this._CertificateUpdateService.templateDetails.layout.dynamicElements.forEach(
                            (element) => {
                                this.dynamicFieldList.forEach((ele: any) => {
                                    if (element.text == ele.title) {
                                        ele.isSelected = 1;
                                    }
                                });

                            }
                        );
                }
            } else {
                this.dynamicFieldList = [];
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['currentTab']) {
            console.log('Current tab changed to:', this.currentTab);
            // Reset the dynamic fields when tab changes
            this.getdynamicFields(this.currentTab);
        }
    }

    ngOnInit(): void {
        console.log("isFor", this.isForName);
        // this.getdynamicFields();
    }

    getdynamicFields(currentTab) {
        // this._CertificateToolService.dynamicFieldList;

        console.log("currentTab in right side nav in get dynamic fields", this._AddEditEventService.dynamicFields)

        if (currentTab == "Contact Actions") {
            this.getContactDynamicFields()
        } else {
            const tempArr: any = this._AddEditEventService.dynamicFields;
            tempArr.map((item: any) => (item["isSelected"] = 0));
            console.log("tempArr", tempArr);
            this._CertificateToolService.dynamicFieldList.next(tempArr);
        }



    }


    getContactDynamicFields() {

        this._CertificateUpdateService.getDynamicFieldsForContact({ isCertificateGeneration: 1 }).then((res: any) => {
            console.log("res in getContactDynamicFields", res);
            if (res.status == 200) {
                this._CertificateToolService.dynamicFieldList.next(res.data);
            } else {
                this._MatSnackBar.open(res.message, 'OKAY', { duration: 3000 });
            }
        })


    }


    onSelectField(field) {
        console.log("field", field);
        console.log("this.isForName", this.isForName, "this.dynamicFieldList", this.dynamicFieldList);

        if (this.isForName != "certificate") {
            field.isSelected = field.isSelected == 0 ? 1 : 0;
            if (this.isForName == "socialPost") {
                this._SocialSharePostService.selectedField.emit(field);
                this._SocialSharePostService.dynamicFieldList.next(
                    this.dynamicFieldList
                );
            } else if (this.isForName == "badgeDesign") {
                this._CreateBadgeDesignService.selectedField.emit(field);
                this._CreateBadgeDesignService.dynamicFieldList.next(
                    this.dynamicFieldList
                );
            } else {
                this._CertificateToolService.selectedField.emit(field);
                this._CertificateToolService.dynamicFieldList.next(
                    this.dynamicFieldList
                );

                // Add text value to dynamicElements
                if (this._CertificateUpdateService.templateDetails?.layout?.dynamicElements) {
                    const existingElement = this._CertificateUpdateService.templateDetails.layout.dynamicElements.find(
                        (element) => element.text === field.createField
                    );

                    if (!existingElement) {
                        const newElement = {
                            text: field.createField,
                            fieldName: `{{${field.title}}}`,
                            fontSize: 20,
                            lineHeight: 20,
                            width: 'auto',
                            fontFamily: "Barlow",
                            fontColor: '#000',
                            display: true,
                            bold: false,
                            transform: 'lowercase',
                            fontWeight: '500',
                            underline: false,
                            italic: false,
                            align: 'left',
                            opacity: 1,
                            rotate: 0,
                            position: {
                                top: 10,
                                left: 20,
                                tTop: 0,
                                tLeft: 0
                            }
                        };
                        this._CertificateUpdateService.templateDetails.layout.dynamicElements.push(newElement);
                    }
                }
            }
        } else {
            this._CertificateToolService.selectedField.emit(field);
            this._CertificateToolService.dynamicFieldList.next(
                this.dynamicFieldList
            );
        }
    }

    close() {
        this.dropClose.emit();
    }
}
